import React from 'react';
import { MdSupervisedUserCircle } from 'react-icons/md';

import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Button, { ButtonType } from 'legacy/common/components/button/Button';
import OrganizationsList from './OrganizationsList';
import UsersList from './UsersList';
import { useTranslation } from 'react-i18next';

function OrganizersGuestsModal({ onClose, isOpen, data }) {
  const { t } = useTranslation(['events', 'common']);
  return (
    <Modal
      visible={isOpen}
      onClose={onClose}
      type={ModalType.SMALL}
      title={t('events:organizersDetails.organizers')}
      icon={<MdSupervisedUserCircle size={20} />}
      renderFooter={() => (
        <Button type={ButtonType.Primary} onClick={onClose}>
          {t('common:buttons.close')}
        </Button>
      )}
    >
      <div className="pt-7 pb-[70px] px-4">
        {data.groups.length > 0 && (
          <div className="pb-7">
            <div className="pb-1">
              {t('events:organizersDetails.organizations')}
            </div>
            <OrganizationsList users={data.groups} />
          </div>
        )}
        <div className="pb-7">
          <div className="pb-1">{t('events:organizersDetails.cohosts')}</div>
          <UsersList users={[...data.cohosts, data.host]} />
        </div>
        {data.operators.length > 0 && (
          <div className="pb-7">
            <div className="pb-1">
              {t('events:organizersDetails.operators')}
            </div>
            <UsersList users={data.operators} />
          </div>
        )}
        {data.scanners.length > 0 && (
          <div className="pb-7">
            <div className="pb-1">{t('events:organizersDetails.scanners')}</div>
            <UsersList users={data.scanners} />
          </div>
        )}
        {data.photographers.length > 0 && (
          <div>
            <div className="pb-1">
              {t('events:organizersDetails.photographers')}
            </div>
            <UsersList users={data.photographers} />
          </div>
        )}
      </div>
    </Modal>
  );
}

export default OrganizersGuestsModal;
